import apiCall from '../../utility/api';

export const type: { value: string } = { value: 'automation' };

const fetchdartTemplateList = async (whereCondition: object) => {
    try {
        return await apiCall(`/${type.value}/getDartList`, whereCondition);
    } catch (error) {
        console.log("fetchdartTemplateList error=", error);
        return { data: [], status: 'failed' };
    }
};

const fetchDartDetails = async (dartid: number) => {
    try {
        return await apiCall(`/${type.value}/getDartDetails`, { dartid: dartid });
    } catch (error) {
        console.log("fetchDartDetails error=", error);
        return { data: [], status: 'failed' };
    }
};

const fetchJsonSchema = async (dartid: number) => {
    try {
        return await apiCall(`/${type.value}/getSchema`, { dartid: dartid });
    } catch (error) {
        console.log("fetchJsonSchema error=", error);
        return { data: [], status: 'failed' };
    }
};

const fetchAutomationList = async (whereCondition: any, limit: number | null = null, offset: number | null = null) => {
    try {
        return await apiCall(`/${type.value}/getList`, { ...whereCondition, limit, offset });
    } catch (error) {
        console.log("fetchAutomationList error=", error);
        return { data: [], status: 'failed' };
    }
};

const fetchAutomationListCnt = async (whereCondition: any) => {
    try {
        return await apiCall(`/${type.value}/getCount`, whereCondition);
    } catch (error) {
        console.log("fetchAutomationListCnt error=", error);
        return { data: [], status: 'failed' };
    }
}

const fetchExportData = async (whereCondition: object) => {
    try {
        return await apiCall(`/${type.value}/getList`, whereCondition);
    } catch (error) {
        console.log("fetchAutomationList error=", error);
        return { data: [], status: 'failed' };
    }
};

const importData = async (data: any) => {
    try {
        return await apiCall(`/${type.value}/import`, data);
    } catch (error) {
        console.log("importData error=", error);
        return { data: [], status: 'failed' };
    }
};
const deleteAutomation = async (ids: number[], types: string = '', tenant: string = '') => {
    try {
        return await apiCall(`/${type.value}/delete`, { id: ids, types: types, tenant: tenant });
    } catch (error) {
        console.log("deleteAutomation error=", error);
        return { data: { affected_rows: -1 }, status: 'failed' };
    }
}

const duplicateAutomationFunc = async (ids: number[], types: string = '', tenant: string = '') => {
    try {
        return await apiCall(`/${type.value}/duplicate`, { id: ids, types: types, tenant: tenant });
    } catch (error) {
        console.log("duplicateAutomation error=", error);

        return { data: { affected_rows: -1 }, status: 'failed' };
    }
}

const addAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, types: string, tenant: string) => {
    try {
        return await apiCall(`/${type.value}/add`, {
            types: types,
            tenant: tenant,
            name: automationName,
            description: description,
            formData: jsonVal,
            dartNo: dartid,
        });
    } catch (error) {
        console.log("addAutomation error=", error);
        return { status: false };
    }
};

const editAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, id: number, tenant: string, automationType: string) => {
    try {
        return await apiCall(`/${type.value}/update`, {
            types: automationType,
            tenant: tenant,
            id: id,
            name: automationName,
            description: description,
            formData: jsonVal,
            dartNo: dartid,
        });
    } catch (error) {
        return { status: 'failed' };
    }
};

const getDartDetails = async (dartid: number, setDartSpecs: any) => {
    try {
        const { data, status } = await fetchDartDetails(dartid);

        if (status === 'success' && data.length > 0) {
            setDartSpecs(data);
        } else {
            setDartSpecs([]);
        }
    } catch (error) {
        console.log("getDartDetails error=", error);
        setDartSpecs([]);
    }
};

const getAutomationListCnt = async (whereCondition: object, setTotalRecords: any = '', setTotalPages: any = '', type = 'set') => {
    try {
        const { data, status } = await fetchAutomationListCnt(whereCondition);

        if (type === 'set') {
            if (status === 'success') {
                setTotalRecords(data.totalRecords);
                setTotalPages(data.totalPages);
            } else {
                setTotalRecords(0);
                setTotalPages(1);
            }
        } else {
            return data;
        }
    } catch (error) {
        console.log("getAutomationListCnt error=", error);

        if (type === 'set') {
            return { totalRecords: 0, totalPages: 0 };
        } else {
            setTotalRecords(0);
            setTotalPages(1);
        }
    }
}

const validateAutomationName = async (whereCondition: object, setNameValidationFlag: any) => {
    try {
        const { status, msg } = await apiCall('/automation/getList', whereCondition);

        if (status === 'success') {
            msg === "name available" ? setNameValidationFlag(true) : setNameValidationFlag(false);
        }

        //props.setValidationText(msg);
    } catch (error) {
        console.log("validateAutomationName error=", error);

        setNameValidationFlag(false);
        //props.setValidationText('');
    }
}

export { fetchdartTemplateList, fetchDartDetails, fetchJsonSchema, fetchAutomationList, fetchAutomationListCnt, fetchExportData, deleteAutomation, addAutomation, editAutomation, getDartDetails, getAutomationListCnt, duplicateAutomationFunc, importData, validateAutomationName }